<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات امتیاز دستگاه ها</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input [(ngModel)]="CustomerName" type="text" class="form-control"
            placeholder="برای جستجوی اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">وضیعت</label>
          <select class="custom-select" [(ngModel)]="SubmitAccept" name="SubmitAccept">
            <option value="0">همه موارد</option>
            <option value="1">تایید شده ها</option>
            <option value="-1">تایید نشده ها</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">محل انجام</label>
          <select class="custom-select" [(ngModel)]="LocationOfCalibration" name="LocationOfCalibration">
            <option value="0">همه موارد</option>
            <option value="1">آزمایشگاه</option>
            <option value="2">سایت</option>
          </select>
        </div>

      </div>

      <div class="row">


        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> کاشناس </label>
          <app-ExpertCalibrationOption [inner_Expert_Lab]="true"
            (OnBack_ExpertCalibration_Action)="OnGet_ExpertCalibration_Action($event)">

          </app-ExpertCalibrationOption>
        </div>


        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام دستگاه </label>
          <input [(ngModel)]="DeviceName" type="text" class="form-control"
            placeholder="برای جستجوی اینجا تایپ کنید ...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-12">

          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Point(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;">
            <i class="fa fa-file-excel-o"></i> Excel کالیبراسیون
          </button>

          <button *ngIf="!Procssing" (click)="exportPMExcel()" type="button" class="btn btn-success"
            style="margin-left: 5px;">
            <i class="fa fa-file-excel-o"></i> Excel PM
          </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <section class="charts-wrapper" dir="rtl">
        <article class="chart-card device-point2-years-section">
          <div class="device-point2-years-toolbar">
            <button type="button" class="btn btn-info device-point-years-button" [disabled]="isLoadingDevicePoint2Years"
              (click)="loadDevicePoint2Years()">
              <span *ngIf="!isLoadingDevicePoint2Years"><i class="fa fa-bar-chart"></i> نمایش مقایسه سالانه T4</span>
              <span *ngIf="isLoadingDevicePoint2Years"><i class="fa fa-spinner fa-spin"></i> در حال دریافت اطلاعات (چند
                دقیقه زمان نیاز دارد) ...</span>
            </button>
            <select *ngIf="devicePoint2YearFullNames.length > 0" class="custom-select device-point-years-select"
              [(ngModel)]="selectedDevicePoint2YearFullName" (change)="onDevicePoint2YearFullNameChange()">
              <option *ngFor="let fullName of devicePoint2YearFullNames" [ngValue]="fullName">{{fullName}}</option>
            </select>
          </div>
          <div class="chart-scroll">
            <div *ngIf="devicePoint2YearsChartHasData" class="chart-container device-point2-years-chart-container"
              [style.min-width]="devicePoint2YearsChartMinWidth">
              <canvas #devicePoint2YearsChart="base-chart" baseChart [datasets]="devicePoint2YearsChartData"
                [labels]="persianMonths" [options]="devicePoint2YearsChartOptions" [plugins]="chart2Plugins"
                [legend]="true" [type]="barChartType"></canvas>
            </div>
            <div *ngIf="devicePoint2YearsLoaded && !isLoadingDevicePoint2Years && !devicePoint2YearsChartHasData"
              class="chart-empty">
              اطلاعاتی برای نمایش وجود ندارد.
            </div>
          </div>
        </article>
        <article class="chart-card">
          <div class="chart-card__header">
            <h5 class="chart-title">جمع کل T4 به تفکیک کارشناس</h5>
          </div>

          <div class="chart-scroll">
            <div *ngIf="Procssing" class="chart-loading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span>در حال ساخت نمودار...</span>
            </div>

            <div *ngIf="!Procssing && chart1HasData" class="chart-container chart1-container"
              [style.min-width]="chart1MinWidth">
              <canvas #chart1Chart="base-chart" baseChart [datasets]="chart1Data" [labels]="chart1Labels"
                [options]="chart1Options" [plugins]="chart1Plugins" [legend]="chart1Legend" [type]="barChartType">
              </canvas>
            </div>

            <div *ngIf="!Procssing && !chart1HasData" class="chart-empty">
              اطلاعاتی برای نمایش نمودار کلی وجود ندارد.
            </div>
          </div>
        </article>

        <article class="chart-card">
          <div class="chart-card__header">
            <h5 class="chart-title">مقایسه T4 کارشناسان در ماه‌های مختلف</h5>
          </div>

          <div class="chart-scroll">
            <div *ngIf="Procssing" class="chart-loading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span>در حال ساخت نمودار...</span>
            </div>

            <div *ngIf="!Procssing && chart2HasData" class="chart-container chart2-container"
              [style.min-width]="chart2MinWidth">
              <canvas baseChart [datasets]="chart2Data" [labels]="chart2Labels" [options]="chart2Options"
                [plugins]="chart2Plugins" [legend]="chart2Legend" [type]="barChartType">
              </canvas>
            </div>

            <div *ngIf="!Procssing && !chart2HasData" class="chart-empty">
              اطلاعاتی برای نمایش نمودار ماهانه وجود ندارد.
            </div>
          </div>
        </article>
      </section>


      <h5 class="mt-4">امتیاز کالیراسیون</h5>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام کارشناس </th>
              <th>مشتری</th>
              <th>نام دستگاه </th>
              <th>زمان تحویل کار (آغاز) </th>
              <th>زمان ثبت گواهی نامه</th>
              <th>شماره گواهی نامه</th>
              <th>شرح کنترل کننده</th>
              <th>تاریخ کنترل</th>
              <th>کنترل کننده</th>
              <th>زمان اتمام کار (پایان) </th>
              <th>روز</th>
              <th>امتیاز روز</th>
              <th>امتیاز</th>
              <th>بازنگری</th>

              <th>تعرفه</th>
              <th>هزینه</th>
              <th>آورده</th>

              <th>T4</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Calibration| paginate
            : {
                id: 'DataList_KartableTable',
                itemsPerPage: 20,
                currentPage: page,
                totalItems: (DataList_Calibration
                ).length
              }">
              <td>{{DataList_Calibration.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.title}}</td>
              <td>{{item.tarikh_tahvil}}</td>
              <td>{{item.tarikh_sbat}}</td>
              <td>{{item.certificate_user_code}}</td>
              <td>{{item.controller_dsc}}</td>
              <td>{{item.controller_date}}</td>
              <td>{{item.controller_user}}</td>
              <td>{{item.tarikh_khoroj}}</td>
              <td>{{item.day}}</td>
              <td>{{item.daypoint}}</td>
              <td>{{item.point}}</td>
              <td (click)="openModal(template,item.controller)">
                <span style="text-decoration: underline;cursor: pointer;">{{item.controller.length}}</span>
              </td>

              <td (click)="openModal1(template1,item.tariff)">
                <span style="text-decoration: underline;cursor: pointer;">{{item.tariff[0]}}</span>
              </td>

              <td>{{item.tariff[7]}}</td>
              <td>{{item.tariff[8]}}</td>

              <td>{{item.t4}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls id="DataList_KartableTable" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="page = $event">
      </pagination-controls>

      <br/>
      <br/>

      <h5 class="mt-4">امتیاز PM</h5>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #2563eb; color: white;">
            <tr>
              <th>#</th>
              <th>کارشناس</th>
              <th>تجهیز</th>
              <th>الگوی PM</th>
              <th>آیتم PM</th>
              <th>تاریخ انجام</th>
              <th>زمان تقریبی</th>
              <th>تعداد آیتم‌های الگو</th>
              <th>T4 آیتم</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of DataList_PM_V2 | paginate: { id: 'DataList_PMTable', itemsPerPage: 20, currentPage: pmPage, totalItems: DataList_PM_V2.length }">
              <td>{{DataList_PM_V2.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.title}}</td>
              <td>{{item.pmTemplateTitle}}</td>
              <td>{{item.pmItemTitle}}</td>
              <td>{{item.tarikh_tahvil}}</td>
              <td>{{item.pmTimeEstimated}}</td>
              <td>{{item.pmTemplateItemCount}}</td>
              <td>{{item.t4}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls id="DataList_PMTable" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="pmPage = $event"></pagination-controls>
    </div>

  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> متن های بازنگری </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Baznegari?.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <ul>
            <li *ngFor="let item of Datalist_Baznegari">
              {{item}}
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Baznegari?.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #template1>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> جزئیات تعرفه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Baznegari1?.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">تعرفه</label>
          <input disabled value="{{Datalist_Baznegari1[1]}}" type="text" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">افزایش مدیر</label>
          <input disabled value="{{Datalist_Baznegari1[2]}}" type="text" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">تخفیف</label>
          <input disabled value="{{Datalist_Baznegari1[4]}} ({{Datalist_Baznegari1[3]}} % )" type="text"
            class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">ارزش افزوده</label>
          <input disabled value="{{Datalist_Baznegari1[6]}} ({{Datalist_Baznegari1[5]}} % )" type="text"
            class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">تعرفه اضافه تجهیز (ریال)</label>
          <input disabled value="{{Datalist_Baznegari1[9]}}" type="text" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">تعرفه اضافه تجهیز (درصد)</label>
          <input disabled value="{{Datalist_Baznegari1[10]}} %" type="text" class="form-control">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Baznegari1?.hide()">بستن</button>
  </div>
</ng-template>

<table id="excel-table-calibration" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>نام کارشناس </th>
      <th>مشتری</th>
      <th>نام دستگاه </th>
      <th>زمان تحویل کار (آغاز) </th>
      <th>زمان ثبت گواهی نامه</th>
      <th>شماره گواهی نامه</th>
      <th>شرح کنترل کننده</th>
      <th>تاریخ کنترل</th>
      <th>کنترل کننده</th>
      <th>زمان اتمام کار (پایان) </th>
      <th>روز</th>
      <th>امتیاز روز</th>
      <th>امتیاز</th>
      <th>بازنگری</th>

      <th>تعرفه</th>
      <th>هزینه</th>
      <th>آورده</th>
      <th>T4</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Calibration">
      <td>{{DataList_Calibration.indexOf(item)+1}}</td>
      <td>{{item.fullname}}</td>
      <td>{{item.customer}}</td>
      <td>{{item.title}}</td>
      <td>{{item.tarikh_tahvil}}</td>
      <td>{{item.tarikh_sbat}}</td>
      <td>{{item.certificate_user_code}}</td>
      <td>{{item.controller_dsc}}</td>
      <td>{{item.controller_date}}</td>
      <td>{{item.controller_user}}</td>
      <td>{{item.tarikh_khoroj}}</td>
      <td>{{item.day}}</td>
      <td>{{item.daypoint}}</td>
      <td>{{item.point}}</td>
      <td>{{item.controller.length}}</td>

      <td>{{item.tariff[0]}}</td>
      <td>{{item.tariff[7]}}</td>
      <td>{{item.tariff[8]}}</td>

      <td>{{item.t4}}</td>
    </tr>
  </tbody>
</table>

<table id="excel-table-pm" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>کارشناس</th>
      <th>تجهیز</th>
      <th>مشتری</th>
      <th>الگوی PM</th>
      <th>آیتم PM</th>
      <th>تاریخ انجام</th>
      <th>زمان تقریبی</th>
      <th>تعداد آیتم‌ها</th>
      <th>T4 آیتم</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_PM_V2">
      <td>{{DataList_PM_V2.indexOf(item)+1}}</td>
      <td>{{item.fullname}}</td>
      <td>{{item.title}}</td>
      <td>{{item.customer || '-'}}</td>
      <td>{{item.pmTemplateTitle}}</td>
      <td>{{item.pmItemTitle}}</td>
      <td>{{item.tarikh_tahvil}}</td>
      <td>{{item.pmTimeEstimated}}</td>
      <td>{{item.pmTemplateItemCount}}</td>
      <td>{{item.t4}}</td>
    </tr>
  </tbody>
</table>